import { request } from '../helpers/request';
import { AuthResponse, AuthUser } from '../helpers/types';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface RegisterPayload {
  name: string;
  email: string;
  password: string;
}

export const authApi = {
  login: (payload: LoginPayload) =>
    request<AuthResponse>('/auth/login', {
      method: 'POST',
      body: payload,
      skipAuth: true,
    }),

  register: (payload: RegisterPayload) =>
    request<AuthResponse>('/auth/register', {
      method: 'POST',
      body: payload,
      skipAuth: true,
    }),

  me: () => request<AuthUser>('/auth/me'),
};
